import { createActionHandler, createReducer } from '@pressreader/appstore';

import { CommentsDialogStatus } from '../../types/comments.dialog';
import { OrderBy } from '../../types/order.by';
import {
    commentsDialogClosed,
    commentsDialogClosing,
    commentsDialogOpened,
    commentsDialogOpening,
    initialLoadBegan,
    initialLoadDone,
} from '../actions/common';

interface State {
    popupId: string;
    articleId: string;
    orderBy: OrderBy;
    isLoaded: boolean;
    popupStatus: CommentsDialogStatus;
}

const initialState: State = {
    popupId: '',
    articleId: '',
    orderBy: OrderBy.DateAsc,
    isLoaded: false,
    popupStatus: CommentsDialogStatus.CLOSED,
};

const reducer = createReducer(
    initialState,
    createActionHandler(initialLoadBegan, (state, { payload }) => ({
        ...state,
        isLoaded: false,
        articleId: payload.articleId,
    })),
    createActionHandler(initialLoadDone, (state, { payload }) => ({
        ...state,
        isLoaded: true,
    })),
    createActionHandler(commentsDialogOpening, (state, { payload }) => ({
        ...state,
        popupStatus: CommentsDialogStatus.OPENING,
        articleId: payload.articleId,
    })),
    createActionHandler(commentsDialogOpened, (state, { payload }) => ({
        ...state,
        popupStatus: CommentsDialogStatus.OPEN,
        popupId: payload.popupId,
    })),
    createActionHandler(commentsDialogClosing, (state, { payload }) => {
        const { popupId } = payload;
        if (state.popupId !== popupId) {
            return state;
        }
        return {
            ...state,
            popupStatus: CommentsDialogStatus.CLOSING,
        };
    }),
    createActionHandler(commentsDialogClosed, (state, { payload }) => {
        const { popupId } = payload;
        if (state.popupId !== popupId) {
            return state;
        }
        return {
            ...state,
            popupStatus: CommentsDialogStatus.CLOSED,
        };
    }),
);

export { State, reducer };
